import { render, staticRenderFns } from "./UpdateEmergencyContact.vue?vue&type=template&id=ec52ed50&scoped=true"
import script from "./UpdateEmergencyContact.vue?vue&type=script&lang=js"
export * from "./UpdateEmergencyContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec52ed50",
  null
  
)

export default component.exports